import { BUDGET_SLIDER_GAP_FACTOR } from '@/config/constants';
import { useOptimizationSession } from '@/dashboards/CampaignOptimization/hooks/useOptimizationSession';
import { Typography } from '@analytical-alley/ui';
import { AiOutlineWarning } from 'react-icons/ai';
import BudgetInput from './inputs/BudgetInput';
import MediaKPIInput from './inputs/MediaKPIInput';
import TotalKPIInput from './inputs/TotalKPIInput';

export const TargetField = ({ budget, onChange, disabled }: { budget: number; onChange: (budget: number | undefined) => void; disabled: boolean }) => {
    const { committed, optimizationBase } = useOptimizationSession();

    const result = committed?.result;
    const displayLimits = (() => {
        if (result?.lowestBudget == null || result?.highestBudget == null) return null;
        const min = Math.round(result.lowestBudget);
        const max = Math.round(result.highestBudget);
        if (optimizationBase !== 'budget') return { min, max };
        const gappedMin = Math.round(min * (1 + BUDGET_SLIDER_GAP_FACTOR));
        const gappedMax = Math.round(max * (1 - BUDGET_SLIDER_GAP_FACTOR));
        return gappedMin <= gappedMax ? { min: gappedMin, max: gappedMax } : { min, max };
    })();
    const budgetError: string | undefined = result?.budgetError || undefined;

    const props = { estimatedBudget: budget, setEstimatedBudget: onChange, limits: displayLimits, disabled };
    return (
        <>
            {optimizationBase === 'budget' && <BudgetInput {...props} label="Budget" />}
            {optimizationBase === 'media_kpi' && <MediaKPIInput {...props} label="Media KPI" />}
            {optimizationBase !== 'budget' && optimizationBase !== 'media_kpi' && <TotalKPIInput {...props} label="Total KPI" />}
            {budgetError && (
                <div className="mt-1 flex items-center gap-1 text-amber-600 dark:text-amber-400">
                    <AiOutlineWarning className="shrink-0" />
                    <Typography variant="bodyXS" color="inherit">
                        {budgetError}
                    </Typography>
                </div>
            )}
        </>
    );
};
